<template>
  <div v-if="!isLoading">
    <b-row v-if="operationBilanId == null" align-h="center" class="row mx-0">
      <div class="col-md-5 text-center">
        <img :src="require(`@/assets/images/APRILYOS/empty-table.png`)" alt="no result" class="mt-4 mb-2 no-result-img"
             style="max-height: 25%;">

        <div class="main-color-text-text bold-text level-two-title">
          {{ $t('operation.bilan.emptyTitle') }}
        </div>

        <div class="main-color-text">
          {{ $t('operation.bilan.emptySubtitle.first') }}
        </div>

        <div class="main-color-text">
          {{ $t('operation.bilan.emptySubtitle.second') }}
        </div>

        <b-button class="mt-2" variant="primary" @click="clickOnCreateBtn">
          {{ $t('operation.bilan.create') }}
        </b-button>
      </div>
    </b-row>
    <div v-else>
      <div class="row mx-0 mt-2 mb-3 justify-content-between">
        <div class="main-color-text bold-text"> {{ $t('Operation.bilan.financier').toUpperCase() }}</div>
        <div class="row mx-0 align-items-center">
          <b-link class="main-color-text bold-text mr-3" v-on:click="exportBilan()">
            {{ $t('operation.bilan.exporter') }}
            <file-download-icon size="18"/>
          </b-link>
        </div>
      </div>
      <OperationBilanTable
        ref="operationBilanTable"
        :items-charges="itemsCharges"
        :items-global="itemsGlobal"
        :items-lots="itemsLots"
        :operation-name="this.operation.name"
        :table-fields-charges="tableFieldsCharges"
        :table-fields-global="tableFieldsGlobal"
        :table-fields-lots="tableFieldsLots">
      </OperationBilanTable>
    </div>
  </div>

</template>

<script>
import api from "../../../services/api";
import OperationBilanTable from "../../operationBilan/components/OperationBilanTable";

export default {
  name: "OperationShowBilan",

  components: {
    OperationBilanTable
  },

  props: {
    operationId: {
      default: null
    },
    operationBilanId: {
      default: null
    }
  },

  data() {
    return {
      isLoading: false,
      bilan: true,
      operation: {
        name: null,
        id: null
      },
      tableFieldsCharges: [
        {label: '', key: 'type'},
        {label: 'HT', key: 'HT', thStyle: {width: "15%"}},
        {label: 'TVA', key: 'TVA', thStyle: {width: "15%"}},
        {label: 'TTC', key: 'TTC', thStyle: {width: "15%"}},
      ],
      itemsCharges: [],

      tableFieldsLots: [
        {label: 'Lot', key: 'lot'},
        {label: 'HT', key: 'HT', thStyle: {width: "15%"}},
        {label: 'TVA', key: 'TVA', thStyle: {width: "15%"}},
        {label: 'TTC', key: 'TTC', thStyle: {width: "15%"}},
      ],
      itemsLots: [],

      tableFieldsGlobal: [
        {label: 'Balance financière professionnelle', key: 'nom'},
        {label: '', key: 'taux', thStyle: {width: "15%"}},
        {label: 'TVA', key: 'TVA', thStyle: {width: "15%"}},
        {label: 'Montant', key: 'TTC', thStyle: {width: "15%"}},
      ],
      itemsGlobal: [],
    }
  },

  async mounted() {
    await this.fetchData()
  },

  methods: {
    async fetchData() {
      if (this.operationId) {
        await this.fetchOperation()
      }
      if (this.operationBilanId) {
        await this.fetchBilanData()
      }
    },

    async fetchOperation() {
      this.isLoading = true
      api
        .get(`/operation/${this.operationId}`)
        .then(response => {
          this.operation.name = response.data.name
          this.operation.id = response.data.id
          this.isLoading = false
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    async fetchBilanData() {
      this.isLoading = true
      api
        .get(`/operationBilan/getBilanData/${this.operationId}`)
        .then(response => {
          this.itemsCharges = response.data['itemsCharges']
          this.itemsLots = response.data['itemsLots']
          this.itemsGlobal = response.data['itemsGlobal']
          this.isLoading = false
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationShow',
              params: {
                operationId: this.operationId,
                currentSection: 0,
                message: error.response.data.message
              }
            })
          }
        })
    },

    exportBilan() {
      this.$refs.operationBilanTable.exportToExcel();
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'OperationBilanCreateEdit',
        params: {
          operationId: this.operationId,
          operationBilanId: this.operationBilanId
        }
      })
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/operation/OperationShowTabs/OperationShowBilan.vue